import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { InterfaceService } from '@app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class OpenAIService extends InterfaceService {

  constructor(
      private http: HttpClient
  ) {
    super();
  }

  generateText(prompt) {
    return this.http.post(this.getApiUrl(`getMessageAi`),prompt);
  }

  endSession(){
    return this.http.get(this.getApiUrl(`clearConversation`));
  }
    getTags(value){
        return this.http.post(this.getApiUrl(`getReplaceMessageAi`),value)
    }
}
